<template>
    <v-layout class="service-form"
        style="max-width: 1240px"
    >
        <h3 v-html="title" />
        <v-form ref="form" class="services-form">
            <v-layout wrap row>
                <v-flex xs12>
                    <v-radio-group
                        row
                        v-model="fieldType"
                    >
                        <v-radio
                            label="Гос. номер"
                            value="gosNumber"
                        />
                        <v-radio
                            label="VIN"
                            value="vin"
                        />
                        <v-radio
                            v-if="formType == 'policy'"
                            label="Полис ОСАГО"
                            value="policy"
                        />
                        <v-radio
                            v-if="formType == 'dcard'"
                            label="ДК"
                            value="dcard"
                        />
                    </v-radio-group>
                </v-flex>
                <v-flex d-flex class="field-block gos-number-block" v-if="fieldType == 'gosNumber'">
                    <span class="alert-russian-symbols" v-if="!symbolsRussian">Могут использоваться только русские буквы</span>
                    <v-text-field
                        :label="placeholder"
                        v-model="gosNumber"
                        :rules="[rules.required, rules.number, rules.minCount]"
                        :key="'gosNumber'"
                        validate-on-blur
                        required
                        v-mask="'G QQQ GG QQQ'"
                        @focus="onFocusTextField"
                        @blur="onBlurTextField"
                        @input="onInputGosNumber"
                        ref="gosNumberInput"
                        class="field-upper-text"
                    />
                </v-flex>
                <v-flex d-flex class="field-block gos-number-block" v-if="fieldType == 'vin'">
                    <v-text-field
                        pt-0
                        v-model="vin"
                        :rules="[rules.required, rules.vin]"
                        :key="'vin'"
                        v-mask="'VVVVVVVVVVVVVVVVV'"
                        label="Введите VIN"
                        @input="vin = vinOtoZeroAndUpperCase(vin)"
                        validate-on-blur
                        required
                    />
                </v-flex>
                <v-flex d-flex class="field-block gos-number-block" v-if="fieldType == 'policy'">
                    <v-text-field
                        v-model="policy"
                        :rules="[rules.required, rules.policy]"
                        key="policy"
                        required
                        v-mask="'SSS PPPPPPPPPP'"
                        label="Введите номер полиса"
                        class="field-upper-text"
                    />
                </v-flex>
                <v-flex d-flex class="field-block gos-number-block" v-if="fieldType == 'dcard'">
                    <v-text-field
                        v-model="dcard"
                        :rules="[rules.required, rules.dcard]"
                        :key="'dcard'"
                        required
                        v-mask="'PPPPPPPPPPPPPPP'"
                        label="Введите номер карты"
                        class="field-upper-text"
                    />
                </v-flex>
                <v-btn
                    class="button next-button block"
                    :loading="loading"
                    @click="find"
                >
                    Найти
                </v-btn>
            </v-layout>
        </v-form>
    </v-layout>
</template>
<script>
    export default {
        props: ['title', 'loading', 'type'],
        data: () => ({
            flag: 0,
            placeholder: 'Введите гос. номер',
            placeholderDefault: 'Введите гос. номер',
            fieldType: 'gosNumber',
            symbolsRussian: true,
            gosNumber: null,
            vin: null,
            policy: null,
            dcard: null,
            formType: 'policy',
            rules: {
                required: v => !!v || 'Обязательное поле',
                number: v => /^[АВЕКМНОРСТУХ_\d\s]{4,}$/.test(v) || 'Неверный формат',
                minCount: v => ( v && v.replace(/(?!-)[^0-9А-Я]/g, "").length >=8 ) || 'Введите номер автомобиля',
                vin: v => /^[\dABCDEFGHJKLMNPRSTUVWXYZ\*]{17}$/.test(v) ||
                        'Должен содержать 17 знаков. Не использовать I (i), O (o), Q (q)',
                policy: v=> /^[А-Я]{3} \d{10}$/.test(v),
                dcard: v=> /^\d{15}$/.test(v),
            },
        }),

        created: function() {
            if (this.type) {
                this.formType = this.type
            }
        },

        methods: {

            onFocusTextField() {
                this.placeholder = 'А 123 АА 777'
            },

            onBlurTextField() {
                if (!this.gosNumber) {
                    this.placeholder = this.placeholderDefault
                }
                else{
                    this.placeholder = null
                }
            },

            onInputGosNumber(value) {
                let string = value.replace(/(?!-)[^a-zA-Z0-9а-яА-Я]/g, "")

                if (this.flag == 0) {
                    this.flag = 1
                    if (/[a-zA-Z]/.test(string)) {
                        this.symbolsRussian = false
                    } else {
                        this.symbolsRussian = true
                    }
                } else {
                    this.flag = 0
                }
                if (string == '' || value.slice(-1) == ' ') {
                    this.flag = 0
                }
                this.gosNumber = this.gosNumber.toUpperCase()
            },

            vinOtoZeroAndUpperCase(value) {
                if (!value) return null;
                if (value.includes('*')) return
                this.vin = value.toString().toUpperCase().replace(/O/g, '0')
                return value;
            },

            stringToUpper: function(value) {
                if (!value) return null;
                return value.toString().toUpperCase();
            },

            find() {
                if (!this.$refs.form.validate()) {
                    return
                }
                let data = {
                    'formType' : this.formType,
                    'type' : this.fieldType,
                    'gosNumber' : this.gosNumber ? this.gosNumber.replace(/(?!-)[^0-9А-Я]/g, "") : null,
                    'vin' : this.vin ? this.vin : null,
                    'policy' : this.policy ? this.policy : null,
                    'dcard' : this.dcard ? this.dcard : null
                }
                this.$emit('find', data)
            }

        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/services/ServicesRequestForm.vue